import { ProductType } from '~/core/enums';
import { convertProductsToProductDetailsList } from '~/core/utils';

export const convertCutoutsToProductDetails =
  convertProductsToProductDetailsList(ProductType.CUTOUT);
